
export default {
    data() {
        return {
            avatar: "@/assets/no-image.jpg",
            phone: '',
            nickname: 'Dear',
            lat: '',
            long: '',
            lastTextMessages: '',
            lastTime: '',
            file: '',
        }

    },

    created() {

        window.onAvatarChanged = (avatar) => {
             console.log("Event: avatar changed: " + avatar);
            this.avatar = avatar;
        }

        window.onNicknameChanged = (nickname) => {
            console.log("Event: nickname changed: " + nickname);
            this.nickname = nickname;
        };

    },


}